// src/pages/LandingPage.js
import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesPage from './ServicesPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';

function LandingPage() {
    return (
        <div>
            <HeroSection />
            <ServicesPage />
            <AboutPage />
            <ContactPage />
        </div>
    );
}

export default LandingPage;
